import { z } from "zod";
import { useMultipleUrlStates } from "../../../utils/hooks/useMultipleUrlStates/useMultipleUrlStates";
import { isEqual } from "radash";
import { VariantSignatures } from "@libry-content/integrations";

const variantParameterSchema = z.object({
  language: z.string().optional(),
  type: z.string().optional(),
  isbn: z.string().optional(),
  manifestationId: z.string().optional(),
  externalContentService: z.string().optional(),
});

export type VariantState = z.infer<typeof variantParameterSchema>;

export type SetVariantState = (signatures: Partial<VariantSignatures>) => void;

export const useCurrentVariantUrlState = () => {
  const [currentVariantState, setCurrentVariantState] = useMultipleUrlStates(variantParameterSchema);
  const setVariantState: SetVariantState = (signatures) => {
    const newVariantState: VariantState = {
      language: signatures.languagesSignature,
      type: signatures.documentTypeSignature,
      externalContentService: signatures.externalContentServiceOriginSignature,
      isbn: undefined,
      manifestationId: undefined,
    };
    if (isEqual(newVariantState, currentVariantState)) {
      return; // No change
    }

    setCurrentVariantState(newVariantState);
  };

  return { currentVariantState, setVariantState };
};
